import { Reveal, Overline } from "./Reveal";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "Un travail d'orfèvre. Mes ongles n'ont jamais été aussi beaux — et l'accueil est adorable.",
    name: "Camille R.",
    service: "Pose gel",
  },
  {
    quote: "Mes extensions de cils tiennent parfaitement. Armina est d'une précision incroyable, je ne confierais mon regard à personne d'autre.",
    name: "Inès B.",
    service: "Volume russe",
  },
  {
    quote: "Enfin des sourcils parfaits au réveil. Le microblading a littéralement changé ma routine du matin.",
    name: "Sarah M.",
    service: "Microblading",
  },
];

export default function Testimonials() {
  return (
    <section id="avis" className="mx-auto max-w-7xl px-6 py-28 lg:px-12 lg:py-40" data-testid="testimonials-section">
      <Reveal>
        <Overline className="mb-6">Elles nous font confiance</Overline>
        <h2 className="font-display max-w-2xl text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[var(--brand-dark)]">
          Leur plus belle <span className="italic font-light text-[var(--brand-accent)]">recommandation.</span>
        </h2>
      </Reveal>
      <div className="mt-20 grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12} className={i === 1 ? "md:translate-y-10" : ""}>
            <figure className="flex h-full flex-col justify-between border border-black/5 bg-[var(--brand-section)] p-10" data-testid={`testimonial-${i}`}>
              <div>
                <div className="flex gap-1 text-[var(--brand-accent)]" aria-label="5 étoiles">
                  {[...Array(5)].map((_, s) => <Star key={s} size={14} fill="currentColor" strokeWidth={0} />)}
                </div>
                <blockquote className="font-display mt-6 text-2xl font-light italic leading-snug text-[var(--brand-dark)]">
                  « {t.quote} »
                </blockquote>
              </div>
              <figcaption className="mt-8">
                <p className="text-sm font-medium text-[var(--brand-dark)]">{t.name}</p>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[var(--brand-accent)]">{t.service}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
